import { fetchApi } from '@/config/axiosSetting';
import {
  GetBodyAdjusterImageTabsAlertsQueryParamType,
  IGetBodyAdjusterImageTabsAlertsQueryResponse,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyAdjusterImageTabsAlerts/getBodyAdjusterImageTabsAlertsQuery.type';

export const getBodyAdjusterImageTabsAlertsQueryFunctions = (
  params: GetBodyAdjusterImageTabsAlertsQueryParamType,
): Promise<IGetBodyAdjusterImageTabsAlertsQueryResponse> =>
  fetchApi.get(`body/reports/${params.id}/images/adjuster/entry_tabs/alerts/`);
